// Dashboard.jsx
// Main doctor view — shows the patient queue and switches to the video room
// when the doctor admits a patient.

import { usePatientQueue } from "../hooks/usePatientQueue.js";
import PatientQueue         from "../components/PatientQueue.jsx";
import VideoRoom            from "../components/VideoRoom.jsx";
import { useNavigate,Link } from "react-router-dom";
import DashboardTabs from "../components/DashboardTabs.js";

export default function VedioQueuePage() {
    const navigate = useNavigate();

  const {
    sessions,
    activeSession,
    callStatus,
    queueError,
    callError,
    admitPatient,
    endCall,
    forceEndSession,
    refreshQueue,
  } = usePatientQueue();

  // ── In a video call ───────────────────────────────────────────────────
  if (callStatus === "in-call" || callStatus === "connecting") {
    return (
      <VideoRoom
        session={activeSession}
        connecting={callStatus === "connecting"}
        onLeave={endCall}
      />
    );
  }

  
  const handleTabChange = (tab) => {
    console.log("Selected tab:", tab);

    if (tab === "visits") {
      // Load visits

      navigate('/doctor-dashboard');
    }

    if (tab === "conference") {
      // Load conference
      navigate('/doctor-vqueue');
    }
  };

  // ── Queue view ────────────────────────────────────────────────────────
  return (
    <div className='container' >
    {/* <DashboardTabs onTabChange={handleTabChange} name={'conference'} /> */}
    <PatientQueue
      sessions={sessions}
      queueError={queueError}
      callError={callError}
      onAdmit={admitPatient}
      onForceEnd={forceEndSession}
      onRefresh={refreshQueue}
    /></div>
  );
}
